import SearchFormView from 'component/search_form/search_form'
import TextControl from 'component/search_form/control/text/text'
import PickManyControl from 'component/search_form/control/pick/pick'

import template from 'component/search_form/groups/groups.tmpl'
import templateMobile from 'component/search_form/groups/groups_mobile.tmpl'

export default SearchFormView.extend({
    templates: {
        default: template,
        mobile: templateMobile,
    },

    events: {
        'click .js-control-submit': '_onSubmitClick',
    },

    render() {
        const template = this.templates[this.options.mobile ? 'mobile' : 'default']
        this.$el.html(template())

        const termControl = this.initSubview(TextControl, {
            name: 'term',
            value: this.model.get('term'),
            placeholder: 'Search groups by keyword',
        })

        const options = this.options.categoryList
            .toJSON()
            .map((category) => ({ name: category.name, value: category.id }))

        // concat with an empty array to convert single value to array
        const categories = [].concat(this.model.get('categories') || []).map((item) => parseInt(item, 10))

        const categoriesControl = this.initSubview(PickManyControl, {
            name: 'categories',
            value: categories,
            options,
            mobile: this.options.mobile,
            placeholder: 'Select a category',
        })

        termControl.render()
        categoriesControl.render()

        this.$('.js-control-term').html(termControl.el)
        this.$('.js-control-categories').html(categoriesControl.el)
        return this
    },

    _onSubmitClick() {
        this.trigger('form:submit', this.model)
    },
})
